// Id platform utilizzato per il back-end per far sapere, dove serve, che le chiamate sono state
// eseguite da questa app
export const APP_ID_PLATFORM = 202;

// Costanti utilizzabili nel maxlength degli input presenti nell' applicazione
export const MAXLENGTH_NAME = 70;
export const MAXLENGTH_SURNAME = 70;
export const MAXLENGTH_NATIONAL_ID_NUMBER = 16;
export const MAXLENGTH_PHONE = 10;
export const MAXLENGTH_EMAIL = 255;
export const MAXLENGTH_USERNAME = 50;
export const MAXLENGTH_PASSWORD = 50;